import { render, staticRenderFns } from "./registerXzpopup.vue?vue&type=template&id=3dd05934&scoped=true&"
import script from "./registerXzpopup.vue?vue&type=script&lang=js&"
export * from "./registerXzpopup.vue?vue&type=script&lang=js&"
import style0 from "./registerXzpopup.vue?vue&type=style&index=0&id=3dd05934&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd05934",
  null
  
)

export default component.exports